module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.project.id) ? _c('div', {
    staticClass: "container mb-30 campaign"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: 'campaign-text-' + _vm.crowdOrRais
  }, [_c('router-link', {
    staticClass: "category",
    attrs: {
      "to": "/crowdfunding"
    }
  }, [_vm._v(_vm._s(_vm.project.category.name))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.project.title))]), _c('br'), _vm._v(" "), (_vm.project.user.id) ? _c('router-link', {
    staticClass: "author",
    attrs: {
      "to": {
        name: 'show_profile',
        params: {
          id: _vm.project.user.id
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.project.user.full_name) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "short-desc"
  }, [_vm._v(_vm._s(_vm.project.description))])], 1), _vm._v(" "), (_vm.project.owner && _vm.isEditable) ? _c('div', {
    class: 'campaign-right-' + _vm.crowdOrRais
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.editRoute,
        params: {
          id: _vm.project.id
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg button-wide",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('edit')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    staticStyle: {
      "background": "#d43f3a",
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Usuń")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "campaign-photo"
  }, [(_vm.project.photo.url) ? _c('img', {
    attrs: {
      "src": _vm.$server_url + _vm.project.photo.url
    }
  }) : _c('img', {
    attrs: {
      "src": require("assets/img/projectPlaceholder.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: 'campaign-right-' + _vm.crowdOrRais
  }, [(_vm.project.crowdfunding) ? _c('strong', [_vm._v("CROWDFUNDING")]) : _c('strong', [_vm._v("FUNDRAISING")]), _vm._v(" "), _c('p', {
    staticClass: "allready-raised"
  }, [_vm._v("\n          " + _vm._s(_vm._f("currencySymbol")(_vm.project.currency)) + " " + _vm._s(_vm._f("price")(_vm.project.collected)) + " / " + _vm._s(_vm._f("price")(_vm.project.to_collect * 100)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "bar-goal"
  }, [_c('div', {
    staticClass: "bar-raised",
    style: ({
      width: _vm.completion + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "mb-30"
  }, [_c('div', {
    staticClass: "goal-percent"
  }, [_vm._v(_vm._s(_vm.completion) + "%")]), _vm._v(" "), (_vm.project.deadline) ? _c('div', {
    staticClass: "days-left"
  }, [_vm._v(_vm._s(_vm._f("daysLeft")(_vm.project.deadline)) + " " + _vm._s(_vm.$t('project.daysLeft')))]) : _c('div', {
    staticClass: "days-left"
  }, [_vm._v(_vm._s(_vm.project.duration) + " " + _vm._s(_vm.$t('project.daysLeft')))])]), _vm._v(" "), (!_vm.project.crowdfunding) ? _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contribution.amount),
      expression: "contribution.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "$5 $20 $50"
    },
    domProps: {
      "value": (_vm.contribution.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.contribution, "amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('reward', {
    attrs: {
      "amount": _vm.contribution.amount,
      "project": _vm.project
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-20"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('p', [(_vm.project.facebook) ? _c('a', {
    attrs: {
      "href": 'https://' + _vm.project.facebook.replace(/(^\w+:|^)\/\//, ''),
      "title": "Facebook"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook-square fa-3x"
  })]) : _vm._e(), _vm._v(" "), (_vm.project.twitter) ? _c('a', {
    attrs: {
      "href": 'https://' + _vm.project.twitter.replace(/(^\w+:|^)\/\//, ''),
      "title": "Twitter"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter-square fa-3x"
  })]) : _vm._e(), _vm._v(" "), (_vm.project.google) ? _c('a', {
    attrs: {
      "href": 'https://' + _vm.project.google.replace(/(^\w+:|^)\/\//, ''),
      "title": "Google +"
    }
  }, [_c('i', {
    staticClass: "fa fa-google-plus-square fa-3x"
  })]) : _vm._e(), _vm._v(" "), (_vm.project.youtube) ? _c('a', {
    attrs: {
      "href": 'https://' + _vm.project.youtube.replace(/(^\w+:|^)\/\//, ''),
      "title": "YouTube"
    }
  }, [_c('i', {
    staticClass: "fa fa-youtube-square fa-3x"
  })]) : _vm._e(), _vm._v(" "), (_vm.project.custom_link) ? _c('a', {
    attrs: {
      "href": 'https://' + _vm.project.custom_link.replace(/(^\w+:|^)\/\//, ''),
      "title": "YourWebsite +"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe fa-3x"
  })]) : _vm._e()])])]), _vm._v(" "), _c('remove-project', {
    attrs: {
      "project": _vm.project,
      "show": _vm.showModal,
      "close": _vm.closeConfirmationModal
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9bdf5478"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Show/Basic.vue
// module id = 830
// module chunks = 1